import { 
    ADMIN_COUNT_FAIL,
    ADMIN_COUNT_REQUEST,
    ADMIN_COUNT_SUCCESS,
    ARTISAN_COUNT_FAIL,
    ARTISAN_COUNT_REQUEST,
    ARTISAN_COUNT_SUCCESS,
    ARTISAN_PRODUCT_COUNT_FAIL,
    ARTISAN_PRODUCT_COUNT_REQUEST,
    ARTISAN_PRODUCT_COUNT_SUCCESS,
    ORDER_COUNT_FAIL,
    ORDER_COUNT_REQUEST,
    ORDER_COUNT_SUCCESS,
    ORDER_DELIVERED_COUNT_FAIL,
    ORDER_DELIVERED_COUNT_REQUEST,
    ORDER_DELIVERED_COUNT_SUCCESS,
    ORDER_PAID_COUNT_FAIL,
    ORDER_PAID_COUNT_REQUEST,
    ORDER_PAID_COUNT_SUCCESS,
    PRODUCT_COUNT_FAIL,
    PRODUCT_COUNT_REQUEST,
    PRODUCT_COUNT_SUCCESS,
    USER_COUNT_FAIL,
    USER_COUNT_REQUEST, 
    USER_COUNT_SUCCESS, 
    USER_REPORT_COUNT_FAIL, 
    USER_REPORT_COUNT_REQUEST,
    USER_REPORT_COUNT_SUCCESS
} from "../constants/CountConstants";
import axios from 'axios';
import { server_api } from "./api";



export const getUserCounts = () => async (dispatch, getState) => {

    try {

        dispatch({
            type: USER_COUNT_REQUEST
        })

        const { authLogin: { info } } = getState();


        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${info.token}`
            }
        }

        const { data } = await axios.get(`${server_api}/api/count/user`, config)

        dispatch({
            type: USER_COUNT_SUCCESS,
            payload: data
        })



    } catch (error) {

        const resErr = error.response && error.response.data.message ? error.response.data.message : error.message


        dispatch({
            type: USER_COUNT_FAIL,
            payload: resErr
        })

    }
}




export const getArtisanCounts = () => async (dispatch, getState) => {

    try {

        dispatch({
            type: ARTISAN_COUNT_REQUEST
        })

        const { authLogin: { info } } = getState();


        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${info.token}`
            }
        }

        const { data } = await axios.get(`${server_api}/api/count/artisan`, config)

        dispatch({
            type: ARTISAN_COUNT_SUCCESS,
            payload: data
        })



    } catch (error) {

        const resErr = error.response && error.response.data.message ? error.response.data.message : error.message


        dispatch({
            type: ARTISAN_COUNT_FAIL,
            payload: resErr
        })

    }
}





export const getAdminCounts = () => async (dispatch, getState) => {

    try {

        dispatch({
            type: ADMIN_COUNT_REQUEST
        })

        const { authLogin: { info } } = getState();


        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${info.token}`
            }
        }

        const { data } = await axios.get(`${server_api}/api/count/admin`, config)

        dispatch({
            type: ADMIN_COUNT_SUCCESS,
            payload: data
        })



    } catch (error) {

        const resErr = error.response && error.response.data.message ? error.response.data.message : error.message


        dispatch({
            type: ADMIN_COUNT_FAIL,
            payload: resErr
        })

    }
}




export const getProductCounts = () => async (dispatch, getState) => {

    try {

        dispatch({
            type: PRODUCT_COUNT_REQUEST
        })

        const { authLogin: { info } } = getState();


        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${info.token}`
            }
        }

        const { data } = await axios.get(`${server_api}/api/count/product`, config)

        dispatch({
            type: PRODUCT_COUNT_SUCCESS,
            payload: data
        })



    } catch (error) {

        const resErr = error.response && error.response.data.message ? error.response.data.message : error.message


        dispatch({
            type: PRODUCT_COUNT_FAIL,
            payload: resErr
        })

    }
}



export const getArtisanProductCounts = () => async (dispatch, getState) => {

    try {

        dispatch({
            type: ARTISAN_PRODUCT_COUNT_REQUEST
        })

        const { authLogin: { info } } = getState();


        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${info.token}`
            }
        }

        const { data } = await axios.get(`${server_api}/api/count/artisan/product`, config)

        dispatch({
            type: ARTISAN_PRODUCT_COUNT_SUCCESS,
            payload: data
        })



    } catch (error) {

        const resErr = error.response && error.response.data.message ? error.response.data.message : error.message


        dispatch({
            type: ARTISAN_PRODUCT_COUNT_FAIL,
            payload: resErr
        })

    }
}



export const getOrderCounts = () => async (dispatch, getState) => {

    try {

        dispatch({
            type: ORDER_COUNT_REQUEST
        })

        const { authLogin: { info } } = getState();


        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${info.token}`
            }
        }

        const { data } = await axios.get(`${server_api}/api/count/order`, config)

        dispatch({
            type: ORDER_COUNT_SUCCESS,
            payload: data
        })



    } catch (error) {

        const resErr = error.response && error.response.data.message ? error.response.data.message : error.message


        dispatch({
            type: ORDER_COUNT_FAIL,
            payload: resErr
        })

    }
}





export const getOrderPaidCounts = () => async (dispatch, getState) => {

    try {

        dispatch({
            type: ORDER_PAID_COUNT_REQUEST
        })

        const { authLogin: { info } } = getState();


        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${info.token}`
            }
        }

        const { data } = await axios.get(`${server_api}/api/count/order/paid`, config)

        dispatch({
            type: ORDER_PAID_COUNT_SUCCESS,
            payload: data
        })



    } catch (error) {

        const resErr = error.response && error.response.data.message ? error.response.data.message : error.message


        dispatch({
            type: ORDER_PAID_COUNT_FAIL,
            payload: resErr
        })

    }
}




export const getOrderDeliveredCounts = () => async (dispatch, getState) => {

    try {

        dispatch({
            type: ORDER_DELIVERED_COUNT_REQUEST
        })

        const { authLogin: { info } } = getState();


        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${info.token}`
            }
        }

        const { data } = await axios.get(`${server_api}/api/count/order/delivered`, config)

        dispatch({
            type: ORDER_DELIVERED_COUNT_SUCCESS,
            payload: data
        })



    } catch (error) {

        const resErr = error.response && error.response.data.message ? error.response.data.message : error.message


        dispatch({
            type: ORDER_DELIVERED_COUNT_FAIL,
            payload: resErr
        })

    }
}




export const getUserReportCounts = () => async (dispatch, getState) => {

    try {

        dispatch({
            type: USER_REPORT_COUNT_REQUEST
        })

        const { authLogin: { info } } = getState();


        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${info.token}`
            }
        }

        const { data } = await axios.get(`${server_api}/api/count/report`, config)

        dispatch({
            type: USER_REPORT_COUNT_SUCCESS,
            payload: data
        })



    } catch (error) {

        const resErr = error.response && error.response.data.message ? error.response.data.message : error.message


        dispatch({
            type: USER_REPORT_COUNT_FAIL,
            payload: resErr
        })

    }
}